import atauniLogo from "../assets/images/logo/atauni_logo.png";
// import tubitakLogo from "../assets/images/logo/TÜBİTAK_logo.svg";

const Navbar = () => {
    return (
        <nav>
            <a href="https://atauni.edu.tr" target="_blank" rel="noreferrer">
                <img src={atauniLogo} alt="atauniLogo" className="atauni-logo"/>
            </a>
            <ul>
                <li><a href="#intro">Hakkında</a></li>
                <li><a href="#presentation">Program</a></li>
                <li><a href="#about">Kimler Katılabilir?</a></li>
                <li><a href="#instructors">Eğitmenler</a></li>
            </ul>
            <a href="https://tubitak.gov.tr" target="_blank" rel="noreferrer">
                {/* <img src={tubitakLogo} alt="tubitakLogo" /> */}
            </a>
        </nav>
    )
}

export default Navbar